import Forms from './Forms.view';

export default Forms;
